export const emptyProperty = {
  address: '',
  area: 0,
  association: '',
  associationScore: '',
  balcony: '',
  description: '',
  elevator: '',
  link: '',
  monthlyCost: 0,
  operationalCostYear: 0,
  price: 0,
  rooms: 0,
  squareMeterPrice: 0,
  tenure: '',
  type: '',
  year: 0,
  scoreAccess: 0,
  scoreBalcony: 0,
  scoreBathroom: 0,
  scoreBedroom: 0,
  scoreCeilingHeight: 0,
  scoreCloset: 0,
  scoreEnergyAndOutlets: 0,
  scoreEntrance: 0,
  scoreFloor: 0,
  scoreGutFeeling: 0,
  scoreKidsFriendly: 0,
  scoreKitchen: 0,
  scoreLaundryRoom: 0,
  scoreLayout: 0,
  scoreLivingRoom: 0,
  scoreNoiseLevel: 0,
  scoreParking: 0,
  scorePetsFriendly: 0,
  scorePhysicalCondition: 0,
  scoreRenovationRules: 0,
  scoreSecurity: 0,
  scoreStorage: 0,
  scoreSurroundings: 0,
  scoreTimeToCityCenter: 0,
  scoreTimeToComute: 0,
  scoreView: 0,
  scoreWaterDistance: 0
}

export const emptyScoresArray = {
  scoreAccess: [],
  scoreBalcony: [],
  scoreBathroom: [],
  scoreBedroom: [],
  scoreCeilingHeight: [],
  scoreCloset: [],
  scoreEnergyAndOutlets: [],
  scoreEntrance: [],
  scoreFloor: [],
  scoreGutFeeling: [],
  scoreKidsFriendly: [],
  scoreKitchen: [],
  scoreLaundryRoom: [],
  scoreLayout: [],
  scoreLivingRoom: [],
  scoreNoiseLevel: [],
  scoreParking: [],
  scorePetsFriendly: [],
  scorePhysicalCondition: [],
  scoreRenovationRules: [],
  scoreSecurity: [],
  scoreStorage: [],
  scoreSurroundings: [],
  scoreTimeToCityCenter: [],
  scoreTimeToComute: [],
  scoreView: [],
  scoreWaterDistance: []
}

export const propertyDescriptions = {
  address: 'Usually the street name, number and city',
  area: 'Size in square meters.',
  association: 'Name of the association that build and/or own the place.',
  associationScore: 'Scores vary from A++ to D, can be found at allabrf.se',
  balcony:
    'How do you like the balcony? Is it pointed to a good direction? Is it big enough? Are there limitations to be aware of?',
  description: '',
  elevator:
    'Availability of the elevator. How new is it? How safe it it? How long is the usual wait?',
  link: 'Link where this apartment can be found on the web',
  monthlyCost:
    'How much per month you will pay on this place? Try to sum stuff that you will bind yourself to, such as Insurance, Heating, Water, Electricity, Internet and even extras such as Spotify and Netflix so you get a full idea of your monthly expenses',
  operationalCostYear:
    'Usually things that are charged yearly, some people prefer to calculate the average of some monthly bills and multiply by 12',
  price: 'Price in Swedish Kronors.',
  rooms: 'How many rooms are available?',
  squareMeterPrice:
    'What is the price of the Square Meter? It is up to you if you want to sum the size of the Balcony or outside area in this field.',
  tenure: '',
  type: '',
  year: 'Which year was it built?',
  scoreAccess:
    'How accessible is this place? Think about public transportation, how well roads and connections are around and how easily you can get to nearby points of interest',
  scoreBalcony:
    'How do you like the balcony? Is it pointed to a good direction? Is it big enough? Are there limitations to be aware of?',
  scoreBathroom:
    'Is the Bathroom big enough for you? Is it well installed? Does it fit or has a bathtub / washing machines? Consider also that if you intend to sell the place in the future, these might come in handy.',
  scoreBedroom:
    'Is the bedroom spacious enough to you? Does it isolate the sound well? Is it well lit and has curtains been installed? Does it fit a bigger bed if you would want it?',
  scoreCeilingHeight:
    'How high is the ceiling? If you were to change clothes under a light would you end up touching it? Is it well installed and painted? Would you change it?',
  scoreCloset:
    'The space designated for your clothing and weaves is big enough? Would you be able to have a place for everything or you would need to mix things together in order to fit? How do you like the instalations and size?',
  scoreEnergyAndOutlets:
    'How many watts does the place handle? If you were to turn on a electric heater and a kettle in the same outlet would it handle it? How is the fuse box? Are outlets well sparced along the areas?',
  scoreEntrance:
    'The entrance is the first thing your guests — and potential future buyers — will see. Is it of good taste? How does the association keep it clean? Is it lit enough? Does it have access for people with special needs?',
  scoreFloor:
    'Can you silently walk through the floor? Is it well installed? Is it scratched, has permanent marks or broken? Do the colors make sense to you?',
  scoreGutFeeling:
    'How do you feel around everything? Does it feel like you would make a good purchase? Does it feel like you would enjoy living there?',
  scoreKidsFriendly:
    'Are there schools around? Is trafic well mainteined? Are there close parks where kids could go play by themselves? Is the place known to be extra safe?',
  scoreKitchen:
    'How are the kitchen instalations? Is the size good to you? Are the appliances in good shape? When was the last time that maintenance looked at it? If something were to break, does the association cover some/all costs?',
  scoreLaundryRoom:
    'Do you have a laundry room nearby? How do you book a time for your laundry? Is it big enough? Are the machines new / in good shape? How many people have access to it at once?',
  scoreLayout:
    'How do you feel about the organization of the rooms? If you wanted to completely reform and change things around, is that a possibility? Does the current layout makes you lose a few unnecessary square meters that could be better spent?',
  scoreLivingRoom:
    'Is the living room well lit? Is it big enough? The disposition makes sense to you? How would you feel having a few guests over?',
  scoreNoiseLevel:
    'Are there many constructions around? Are the doors fit for blocking noise? Are the walls built for noise reduction? Would you have a special neighbour that makes your life miserable?',
  scoreParking:
    'Are there places to park nearby? If so, does the price fit? How long would you have to walk and wait until you get to your vehicle?',
  scorePetsFriendly:
    'Are there special rules for pets? Are there places nearby where you could take your pet? Are the surroundings safe enough?',
  scorePhysicalCondition:
    'The instalations are all in good shape? Do you see something that needs to be fixed, changed, removed or cleaned?',
  scoreRenovationRules:
    'If you wanted to perform renovations, what are the rules for it? How long is the usual wait? What is the extent of renovations you could perform?',
  scoreSecurity:
    'Does the property feel safe? Were there reported criminal activities nearby? If someone tried to break in, what would make it harder?',
  scoreStorage:
    'Do you have extra storage room? Is it big enough? Is it accessible? Is it clean?',
  scoreSurroundings:
    'What would you have nearby? Are there business that you would make use of? Is it in an area that you feel at home?',
  scoreTimeToCityCenter:
    'How long would take you to get to the city center? How do you feel about this time?',
  scoreTimeToComute:
    'How long would take you to get to work or your kids to school? How do you feel about this time?',
  scoreView:
    'Looking through the windows and possibly a balcony or outside area, how satisfied are you with what you see? Do you receive a good amount of Sun?',
  scoreWaterDistance:
    'How long would you have to walk until you reach the sea, lake, river or pound?'
}

export const businessValue = {
  associationScore: 'medium',
  price: 'medium',
  monthlyCost: 'medium',
  rooms: 'medium',
  operationalCostYear: 'medium',
  scorePhysicalCondition: 'medium',
  scoreRenovationRules: 'medium',
  scoreSecurity: 'medium',
  squareMeterPrice: 'medium',
  year: 'medium'
}
export const location = {
  area: 'medium',
  scoreAccess: 'medium',
  scoreKidsFriendly: 'medium',
  scoreNoiseLevel: 'medium',
  scoreParking: 'medium',
  scorePetsFriendly: 'medium',
  scoreSurroundings: 'medium',
  scoreTimeToCityCenter: 'medium',
  scoreTimeToComute: 'medium',
  scoreView: 'medium',
  scoreWaterDistance: 'medium'
}
export const areas = {
  scoreBalcony: 'medium',
  scoreBathroom: 'medium',
  scoreBedroom: 'medium',
  scoreCloset: 'medium',
  scoreKitchen: 'medium',
  scoreLayout: 'medium',
  scoreLivingRoom: 'medium'
}
export const quality = {
  scoreCeilingHeight: 'medium',
  scoreEnergyAndOutlets: 'medium',
  scoreEntrance: 'medium',
  scoreFloor: 'medium',
  scoreGutFeeling: 'medium',
  scoreLaundryRoom: 'medium',
  scoreStorage: 'medium'
}

export const accountPreferences = {
  Areas: areas,
  'Business Value': businessValue,
  Location: location,
  Quality: quality,
  maxPrice: 2500000,
  Favorites: []
}

export const mappedPreference = {
  0: 0,
  disabled: 0,
  low: 0.5,
  medium: 1,
  high: 1.5
}

export const preferencesWeight = {
  Areas: 4,
  'Business Value': 3,
  Location: 2,
  Quality: 1,
  Favorites: 5
}
